<div [@mostrarNotificaciones]="this.notificationService.showNavNotifications ? 'visible' : 'hidden'" class="notification-list" (scroll)="onScroll($event)" >
                <div>
                  <div class="loading-container">
                    <loading *ngIf="this.notificationService.isLoadingNotificationes && notificationList.length !=  0" [isLoading]="true" [isFullSize]="true"></loading>
                  </div>
                  <div>
                     <!-- -- tarjetas de notificacion (este es comentario) --  -->
                    <div [ngClass]="{'notification-seen': notification.isReaded}" [class]="'notification-item notification-'+notification.priority" *ngFor="let notification of notificationList" (click)="onNotificationClick(notification.idAlarm, notification.id)">
                      <div class="col-4 notification-icon">
                        <div class="notificationIconBg">
                          <img class="notificationImg" [src]="'../../../../assets/img/navBar/'+notification.icon"/> 
                        </div>
                      </div>
                      <div class="col-8 notification-item-text">
                        <div class="notification-item-title">
                          {{notification.notificationCategory}}{{ notification.detonatorName ? ' - ' + notification.detonatorName : '' }}
                        </div>
                        <div class="notification-item-description">
                          {{notification.identifier}}
                        </div>
                        <div class="notification-item-date">
                          {{notification.createdIn | date: 'dd-MM-yy HH:mm'}}
                        </div>
                      </div>
                    </div>
  
                    <h1 *ngIf="notificationList.length ==  0  && !this.notificationService.isLoadingNotificationes" style="color: black; text-align: center;">Sin notificaciones</h1>
  
                    <h1 *ngIf="notificationList.length ==  0  && this.notificationService.isLoadingNotificationes" style="color:black">Cargando...</h1>
  
                  </div>
                  <div>
                    <div *ngIf="notificationList.length > 0" class="notification-all-button" >
                      <span (click)="onViewAllNotifications()">Ver todas</span>
                    </div>
                  </div>
                </div>
              </div>